import React, { useEffect, useState } from "react";
import type {
  ShopBannerEntity,
  ShopEntity,
} from "../../../../../../domain/types/company-shop";

interface BannerProps {
  slidingInterval: number;
  bannersData: ShopBannerEntity[] | null;
  shopEntityData: ShopEntity | null;
}

/** 우측 미리보기 안에서 배너를 실제로 슬라이드시키는 캐러셀 */
export const Banner = ({
  bannersData,
  slidingInterval,
  shopEntityData,
}: BannerProps) => {
  const [showingBannerIndex, setShowingBannerIndex] = useState<number>(0);
  const [indexesWithImage, setIndexesWithImage] = useState<number[]>([]);
  useEffect(() => {
    setIndexesWithImage(
      Array.from({ length: bannersData?.length ?? 0 }, (_, i) => i),
    );
  }, [bannersData?.length]);

  useEffect(() => {
    if (!bannersData?.length || bannersData.length === 1) {
      return;
    }

    const timerId = setTimeout(() => {
      setShowingBannerIndex((prevIndex) => {
        return prevIndex + 1;
      });
      if (showingBannerIndex >= bannersData.length - 2) {
        setIndexesWithImage((prev) => {
          const returningValue = [...prev];
          returningValue.push(prev[prev.length - 1] + 1);
          return returningValue;
        });
      }
    }, slidingInterval * 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [
    bannersData?.length,
    indexesWithImage,
    showingBannerIndex,
    slidingInterval,
  ]);

  return (
    <div className="overflow-hidden relative w-full h-full">
      <div className="absolute"></div>
      {bannersData && (
        <>
          <div className="absolute"></div>
          <div
            className="flex flex-row h-full duration-[1s] transition-transform"
            style={{
              transform: `translateX(-${showingBannerIndex * 100}%)`,
            }}
          >
            {bannersData.length &&
              [...indexesWithImage].map((_, index) => {
                const item = bannersData[index % bannersData.length];
                if (item) {
                  return (
                    <div
                      className={`${shopEntityData?.isCarouselLayout ? "p-7" : ""} overflow-hidden flex-shrink-0 object-cover aspect-[700/380] w-full h-full`}
                    >
                      <img
                        className={`w-full h-full object-cover ${shopEntityData?.isCarouselLayout ? "rounded-[20px]" : ""}`}
                        alt={item.title ?? "미리보기 이미지"}
                        src={item.bannerUrl}
                      ></img>
                    </div>
                  );
                } else {
                  return (
                    <div className="flex-shrink-0 object-cover aspect-[700/380] w-full h-full"></div>
                  );
                }
              })}
          </div>
        </>
      )}
    </div>
  );
};
